export default __webpack_public_path__ + "6ec790c089002534f5581b5fd123dab1.jpg";